import apiClient from './client';
import type { Series, CreateSeriesRequest, UpdateSeriesRequest } from '../types';

export const seriesApi = {
  create: async (data: CreateSeriesRequest): Promise<{ id: string }> => {
    const response = await apiClient.post<{ id: string }>('/series', data);
    return response.data;
  },

  getAll: async (teamId?: string): Promise<Series[]> => {
    const params = teamId ? { team_id: teamId } : {};
    const response = await apiClient.get<Series[]>('/series', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Series> => {
    const response = await apiClient.get<Series>(`/series/${id}`);
    return response.data;
  },

  update: async (id: string, data: UpdateSeriesRequest): Promise<Series> => {
    const response = await apiClient.patch<Series>(`/series/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/series/${id}`);
  },
};



